module.exports = __webpack_public_path__ + "img/record_img_4.2cfa56b9.png";